import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	planOnWhiteboard: {
		id: 'backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard',
		defaultMessage: 'Plan on whiteboard',
		description: 'Label for context menu action to plan on whiteboard',
	},
	planOnWhiteboardTry: {
		id: 'backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard-try',
		defaultMessage: 'Try',
		description: 'Label for try lozenge',
	},
	spotlightHeading: {
		id: 'backlog.whiteboards-entrypoint-experiment.spotlight-heading',
		defaultMessage: 'Plan in a whiteboard',
		description: 'Heading for the spotlight on the touchpoint',
	},
	spotlightContent: {
		id: 'backlog.whiteboards-entrypoint-experiment.spotlight-content',
		defaultMessage: 'Link, organize, and plan your work however you want.',
		description: 'Content for the spotlight on the touchpoint',
	},
	spotlightCta: {
		id: 'backlog.whiteboards-entrypoint-experiment.spotlight-cta',
		defaultMessage: 'Try now',
		description: 'CTA for the spotlight on the touchpoint',
	},
	privacyPolicy: {
		id: 'backlog.whiteboards-entrypoint-experiment.privacy-policy',
		defaultMessage: 'Learn more about your data privacy with Atlassian',
		description: "Link to Atlassian's privacy policy",
	},
	dismissFlagTitle: {
		id: 'backlog.whiteboards-entrypoint-experiment.dismiss-flag-title',
		defaultMessage: 'Thanks for letting us know',
		description: 'Title of the flag that shows up when a user dismisses the placeholder template',
	},
	dismissFlagDescription: {
		id: 'backlog.whiteboards-entrypoint-experiment.dismiss-flag-description',
		defaultMessage: 'You won’t see this ad here again.',
		description:
			'Description of the flag that shows up when a user dismisses the placeholder template',
	},
	reasonsModalTitle: {
		id: 'backlog.whiteboards-entrypoint-experiment.reasons-modal-title',
		defaultMessage: 'Why am I seeing this?',
		description: 'Title of the reasons modal',
	},
	reasonsModalExplanation: {
		id: 'backlog.whiteboards-entrypoint-experiment.reasons-modal-explanation',
		defaultMessage:
			"We think <strong>Confluence whiteboards</strong> will improve your team's productivity. The recommendation is based on:",
		description: 'Explanation as to why the placeholder template is being shown',
	},
	reasonsModalBulletOne: {
		id: 'backlog.whiteboards-entrypoint-experiment.reasons-modal-bullet-one',
		defaultMessage: 'the size of your team',
		description: 'First bullet point of the reasons modal',
	},
	reasonsModalBulletTwo: {
		id: 'backlog.whiteboards-entrypoint-experiment.reasons-modal-bullet-two',
		defaultMessage: 'your existing Atlassian products',
		description: 'Second bullet point of the reasons modal',
	},
	adControls: {
		id: 'backlog.whiteboards-entrypoint-experiment.ad-controls',
		defaultMessage: 'Ad controls',
		description: 'Label for the ad controls dropdown',
	},
	bannerIcon: {
		id: 'backlog.whiteboards-entrypoint-experiment.banner-icon',
		defaultMessage: 'Whiteboards banner icon',
		description: 'Label for the icon that appears in the banner',
	},
	banner: {
		id: 'backlog.whiteboards-entrypoint-experiment.banner',
		defaultMessage: 'Create a whiteboard to plan your work',
		description: 'Content for the banner',
	},
	bannerDismiss: {
		id: 'backlog.whiteboards-entrypoint-experiment.banner-dismiss',
		defaultMessage: 'Dismiss whiteboard banner',
		description: 'Label for the icon to dismiss the banner',
	},
});
